import http from "./utils";
import { prefix, mockPrefix } from './constants';

export const getKolBrandKeyMetrics: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/influencer/overview/key_metrics`,
    method: 'post',
    data: payload,
    ignoreRequestId: false,
  }) as Promise<any>;
};

export const getKolBrandProfile: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/influencer/overview/profile`,
    method: 'post',
    data: payload,
    ignoreRequestId: false,
  }) as Promise<any>;
};

export const getKolBrandPerformance: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/influencer/overview/performance`,
    method: 'post',
    data: payload,
    ignoreRequestId: false,
  }) as Promise<any>;
};

export const getInfluencerCreatorList: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/influencer/creator/list`,
    method: 'post',
    data: payload,
    ignoreRequestId: false,
  }) as Promise<any>;
};

export const getInfluencerCreatorTimeline: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/influencer/creator/timeline`,
    method: 'post',
    data: payload,
    ignoreRequestId: false,
  }) as Promise<any>;
};

export const getInfluencerGenreCreatorList: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/influencer/genre/creator/list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getInfluencerGenreTagsStats: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/influencer/genre/creator/tag_stats`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getInfluencerGenreLanguageStats: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/influencer/genre/creator/language_stats`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getInfluencerGenreGameCovereds: (
  payload: any,
) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/influencer/genre/game_covereds`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
